<template>
  <div class="components-page">
    <gameInfoTitle title="元件資訊"></gameInfoTitle>
    <div class="components-detail">
      <table class="components-grid">
        <tr class="components-grid-cell">
          <td class="components-grid-cellImg" colspan="2">
            <div class="img-wrap">
              <gameObjCard
                :type="6"
                :hasName="false"
                :src="detailData.src"
                :quality="detailData.quality"
                :sourceBgType="detailData.IconType"
              >
              </gameObjCard>
            </div>
          </td>
        </tr>
        <tr class="components-grid-cell">
          <td class="components-grid-cellNormal" colspan="2">
            <div class="text-cell-wrap">
              <div class="text-cell">
                <p class="text-cell1">名稱:</p>
                <p class="text-cell2">{{ detailData.componentName || "-" }}</p>
              </div>
              <div class="text-cell">
                <p class="text-cell1">子類型:</p>
                <p class="text-cell2">
                  {{ detailData.moduleSubtype | subTypeFilter }}
                </p>
              </div>
            </div>
          </td>
        </tr>
        <tr class="components-grid-cell">
          <td class="components-grid-cellNormal" colspan="2">
            <div class="text-cell-wrap">
              <div class="text-cell">
                <p class="text-cell1">品質:</p>
                <p class="text-cell2">
                  {{ detailData.quality | qualityFilter }}
                </p>
              </div>
              <div class="text-cell">
                <p class="text-cell1">機率:</p>
                <p class="text-cell2">
                  {{
                    detailData.probabilityLevel
                      ? `Lv${detailData.probabilityLevel}`
                      : "-"
                  }}
                </p>
              </div>
            </div>
          </td>
        </tr>
        <tr class="components-grid-cell">
          <td class="components-grid-cellNormal" colspan="2">
            <div class="text-cell-wrap">
              <div class="text-cell">
                <p class="text-cell1">效果:</p>
                <p
                  class="text-cell2"
                  v-html="detailData.moduleDescription || '-'"
                ></p>
              </div>
            </div>
          </td>
        </tr>
        <tr class="components-grid-cell">
          <td class="components-grid-cellNormal" colspan="2">
            <div class="text-cell-wrap">
              <div class="text-cell">
                <p class="text-cell1">備註:</p>
                <p class="text-cell2">{{ detailData.attention || "-" }}</p>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import gameInfoTitle from "../components/gameInfoTitle.vue";
import gameObjCard from "../components/base/gameObjCard.vue";
export default {
  components: { gameInfoTitle, gameObjCard },
  props: {
    detailData: {
      type: Object,
      required: true,
    },
  },
  filters: {
    subTypeFilter(val) {
      switch (val) {
        case "1":
          return "命中相關";
        case "2":
          return "攻擊方式";
        case "3":
          return "受擊相關";
        case "4":
          return "耐久相關";
        case "5":
          return "AP相關";
        case "6":
          return "戰中效果";
        case "7":
          return "戰後效果";
        case "8":
          return "攻擊结果";
        case "9":
          return "距離相關";
        case "10":
          return "特殊效果";
        case "11":
          return "移動相關";
        default:
          return "-";
      }
    },
    qualityFilter(val) {
      switch (val) {
        case "SSR":
          return "S";
        case "SR":
          return "A";
        case "R":
          return "B";
        default:
          return "-";
      }
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.components-page {
  .components-detail {
    margin-top: 0.12rem;

    .components-grid {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      margin-top: 0.01rem;
      margin-bottom: 0.3rem;

      &-cellImg {
        width: 100%;
        height: 1.6rem;
        border-color: black;
        border-style: solid;
        border-width: 1px;

        .img-wrap {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &-cell:nth-child(odd) {
        background-color: #f2f2f4;
      }

      &-cellNormal,
      &-cellSkill,
      &-cellSkill2 {
        border-color: black;
        border-style: solid;
        border-width: 1px;

        .text-cell-wrap {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .text-cell {
            flex: 1;
            padding: 0 0.2rem;
            display: flex;
            font-size: 0.22rem;
            align-items: center;
            justify-content: center;
            line-height: 0.48rem;
          }

          .text-cell1 {
            font-weight: 600;
            margin-right: 0.2rem;
          }

          .text-cell2 {
            flex: 1;
            color: #404040;
          }
        }
      }

      &-cellNormal {
        height: 0.55rem;
      }

      &-cellSkill {
        height: 0.55rem;

        .skill-icon {
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 1.06rem;
            height: 1.06rem;
            object-fit: contain;
          }
        }

        .skill-info-icon {
          border-color: black;
          border-style: solid;
          border-width: 1px;
        }

        .skill-info-attr {
          height: 0.55rem;
        }
        .text-cell1 {
          font-size: 0.24rem;
        }
        .text-cell2 {
          font-size: 0.22rem;
        }
      }

      &-cellSkill2 {
        height: 1.22rem;

        .skill-info-desc {
          padding: 0.22rem;
          background-color: #f2f2f4;
        }
        .text-cell1 {
          font-size: 0.24rem;
        }
        .text-cell2 {
          font-size: 0.22rem;
        }
      }
    }
  }
}
</style>
